import { render, staticRenderFns } from "./split-apply.vue?vue&type=template&id=190fdbce"
import script from "./split-apply.vue?vue&type=script&lang=js"
export * from "./split-apply.vue?vue&type=script&lang=js"
import style0 from "./split-apply.vue?vue&type=style&index=0&id=190fdbce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports